import {DATE_FORMAT} from "../contstants";
import { format } from 'date-fns';

export const formatDate = (dateString, dateFormat = DATE_FORMAT) => {
    const date = new Date(dateString);
    return format(date, dateFormat);
};